import { ReportsRopaArea } from "../Area"
import { 
    Typography, 
    Paper, 
} from '@mui/material';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { FILTER } from '../filter-types';

export const ReportsRopaCompany = ({company, filter, area, process, data, category, legalBase, processing, position}) => {
    const { t } = useTranslation('mapping');
    // Filtrar áreas
    const filteredAreas = company.areas?.filter((areaFilter) => {
        if (filter === FILTER.AREA && !!area) {
            return areaFilter.name === area
        }
        if (filter === FILTER.PROCESS && !!process) {
            return areaFilter.processes.some((itemProcess) => itemProcess.name === process)
        }
        if (filter === FILTER.DATA && !!data) {
            return areaFilter.processes.some((itemProcess) => {
                return itemProcess.dataMapping.some((dataMap) => dataMap.name === data)
            })
        }
        if (filter === FILTER.CATEGORY && !!category) {
            return areaFilter.processes.some((itemProcess) => {
                return itemProcess.dataMapping.some((dataMap) => dataMap.category === category)
            })
        }
        if (filter === FILTER.PROCESSING && !!processing) {
            return areaFilter.processes.some((itemProcess) => {
                return itemProcess.dataMapping.some((dataMap) => {
                    return dataMap.dataProcessing.some((dataProcess) => {
                        return (dataProcess.processing) === processing
                    })
                })
            })
        }
        if (filter === FILTER.LEGAL_BASE && !!legalBase) {
            return areaFilter.processes.some((itemProcess) => {
                return itemProcess.dataMapping.some((dataMap) => {
                    return dataMap.dataProcessing.some((dataProcess) => {
                        return (dataProcess.legalBase) === legalBase
                    })
                })
            })
        }
        if (filter === FILTER.POSITION && !!position) {
            return areaFilter.processes.some((itemProcess) => {
                return itemProcess.dataMapping.some((dataMap) => {
                    return dataMap.dataProcessing.some((dataProcess) => {
                        return (dataProcess.position) === position
                    })
                })
            })
        }
        return true
    });

    return (
        <>
            {/* Áreas */}
            {!!company.areas && filteredAreas?.map((itemArea, index) => (
                <motion.div
                    key={itemArea.name}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: index * 0.1 }}
                >
                    <ReportsRopaArea
                        area={itemArea}
                        filter={filter}
                        process={process}
                        data={data}
                        category={category}
                        legalBase={legalBase}
                        processing={processing}
                        position={position}
                    />
                </motion.div>
            ))}

            {/* Mensagem quando não há dados */}
            {(!filteredAreas || filteredAreas.length === 0) && (
                <Paper 
                    elevation={1}
                    sx={{ 
                        p: 4, 
                        textAlign: 'center', 
                        borderRadius: 2,
                        bgcolor: '#f5f5f5'
                    }}
                >
                    <Typography variant="h6" color="text.secondary" gutterBottom>
                        {t('ropa.company.noAreas')}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {t('ropa.company.adjustFilters')}
                    </Typography>
                </Paper>
            )}
        </>
    )
}